<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="0"></top-logo>
    <div class="page-login">
      <!-- <div
        class="account_zhezhao_wrapper"
        v-show="show_account_wrapper"
        @click="hide_account_guide($event)"
      ></div>-->
      <!-- 登录部分 -->
      <div class="login-wrap">
        <div class="login-inner w">
          <div class="login-form">
            <div class="login-box" v-if="method == 0">
              <div class="mt">
                <h1>手机扫码，安全登录</h1>
              </div>
              <div class="mc">
                <div class="form">
                  <form name="loginForm" class="rest-form">
                    <div class="login-main">
                      <div class="code-wrap">
                        <img class="code" :src="codeUrl" />
                        <div
                          class="refresh-wrap"
                          v-if="isTimeOut"
                          @click="
                            isTimeOut = false;
                            getCode();
                          "
                        >
                          <i class="el-icon-refresh"></i>
                          <p>点击刷新</p>
                        </div>
                      </div>
                      <el-row class="saoma">
                        <el-col :span="9">
                          <img src="../../assets/images/saoma.png" alt />
                        </el-col>
                        <el-col :span="14">
                          <div>
                            打开
                            <span class="orange">微信</span> |
                            <span class="orange">扫一扫</span>
                          </div>
                          <div>扫一扫登录</div>
                        </el-col>
                      </el-row>
                      <div class="rest-checkbox-wrap mt_20 clearfix">
                        <div>- 其他登录方式 -</div>
                        <div class="forget-password" @click="method = 1">
                          <img src="../../assets/images/account.png" alt />
                          <div>账号密码登录</div>
                        </div>

                        <div class="login_accont_info" @click="method = 2">
                          <img src="../../assets/images/mobile.png" alt />
                          <div>手机号码登录</div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="login-box" v-if="method == 1">
              <div class="mt">
                <h1>账号密码，安全登录</h1>
              </div>
              <div class="mc">
                <div class="form">
                  <form name="loginForm" class="rest-form">
                    <div class="login-main">
                      <div class="form-group">
                        <img src="../../assets/images/user.png" alt />
                        <input
                          type="text"
                          name="email"
                          class="rest-input input-with-icon form-control mobile"
                          v-model="username"
                          placeholder="请输入您的账号"
                        />
                      </div>
                      <div class="form-group">
                        <img src="../../assets/images/lock.png" alt />
                        <input
                          type="password"
                          name="password"
                          class="
                            rest-input
                            input-with-icon
                            form-control
                            password
                            has-icon
                          "
                          v-model="password"
                          placeholder="请输入您的密码"
                        />
                      </div>
                      <div class="form-group" v-show="yzmKey">
                        <img src="../../assets/images/lock.png" alt />
                        <input
                          type="text"
                          name="password"
                          class="
                            rest-input
                            input-with-icon
                            form-control
                            password
                            has-icon
                          "
                          v-model="yzm"
                          placeholder="通过邮箱获取验证码"
                        />
                        <div class="yzm" @click="getYzm">
                          {{
                            yzmTime === 0
                              ? "获取验证码"
                              : this.yzmTime + "s后获取"
                          }}
                        </div>
                      </div>
                      <div class="forget" @click="forget">忘记密码？</div>
                      <div class="btn-wrap">
                        <button
                          type="button"
                          class="btn login-btn"
                          @click="login"
                        >
                          登 录
                        </button>
                      </div>
                      <div
                        v-show="!title"
                        class="rest-checkbox-wrap mt_20 clearfix"
                      >
                        <div>- 其他登录方式 -</div>
                        <div
                          class="forget-password"
                          @click="
                            method = 0;
                            getCode();
                          "
                        >
                          <img src="../../assets/images/scan.png" alt />
                          <div>手机扫码登录</div>
                        </div>

                        <div class="login_accont_info" @click="method = 2">
                          <img src="../../assets/images/mobile.png" alt />
                          <div>手机号码登录</div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="login-box" v-if="method == 2" @click="method = 2">
              <div class="mt">
                <h1>手机号码，安全登录</h1>
              </div>
              <div class="mc">
                <div class="form">
                  <form name="loginForm" class="rest-form">
                    <div class="login-main">
                      <div class="form-group">
                        <img
                          src="../../assets/images/shouji.png"
                          alt
                          style="top: 8px; width: 18px"
                        />
                        <input
                          type="text"
                          name="number"
                          class="rest-input input-with-icon form-control mobile"
                          v-model="user.mobile"
                          placeholder="请输入您的手机号码"
                        />
                      </div>
                      <div class="form-group">
                        <img
                          src="../../assets/images/keyboard.png"
                          style="top: 14px"
                        />
                        <button
                          class="login_get_sms"
                          @click="getVerify"
                          type="button"
                          :disabled="!canSend"
                        >
                          {{ content }}
                        </button>
                        <input
                          type="text"
                          name="number"
                          class="rest-input input-with-icon form-control mobile"
                          v-model="user.sms_code"
                          placeholder="请输入验证码"
                          maxlength="6"
                          @keyup.enter="login2"
                        />
                      </div>
                      <div class="btn-wrap">
                        <button
                          type="button"
                          class="btn login-btn"
                          @click="login2"
                        >
                          登 录
                        </button>
                      </div>
                      <div class="rest-checkbox-wrap mt_20 clearfix">
                        <div>- 其他登录方式 -</div>
                        <div
                          class="forget-password"
                          @click="
                            method = 0;
                            getCode();
                          "
                        >
                          <img src="../../assets/images/scan.png" alt />
                          <div>手机扫码登录</div>
                        </div>

                        <div class="login_accont_info" @click="method = 1">
                          <img src="../../assets/images/account.png" alt />
                          <div>账号密码登录</div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="login-banner"
          :style="'background-image:url(' + backImg + ')'"
        >
          <div class="banner w">
            <div class="banner-bg"></div>
          </div>
        </div>
        <div class="rest-f-tail">
          <div class="footer">
            <div class="rest-f-legal-link">
              <router-link :to="{ name: 'index' }">首页</router-link>
              <router-link :to="{}">关于我们</router-link>
              <router-link :to="{}">联系我们</router-link>
              <router-link :to="{}">企业申请</router-link>
              <router-link :to="{}">用户协议</router-link>
              <!-- <router-link :to="{}">诚聘英才</router-link> -->
              <span>客服电话:400-088-8635</span>
            </div>
            <div class="rest-f-legal-ba">
              <a href="http://www.miibeian.gov.cn" target="_blank"
                >备案/许可证号：沪ICP备17048375号-1</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import LOADINGIMG from "@/assets/images/loading.gif";
import { Loading } from "element-ui";
import backImg from "../../assets/images/logo_bg.png";
export default {
  components: {
    TopHeaderInfo,
    TopLogo
  },
  data() {
    return {
      username: "",
      password: "",
      yzm: "",
      yzmTime: 0,
      yzmKey: false,
      validation: "",
      method: 1,
      dialog: "",
      user: { mobile: "", sms_code: "" },
      canSend: true,
      content: "获取验证码",
      totalTime: 60,
      isTimeOut: false,
      scanTimer: "",
      codeUrl: LOADINGIMG,
      backImg: backImg,
      title: "",
      app_id: "",
      t_data: {}
    };
  },
  watch: {
    method(val) {
      if (val != 0) {
        clearInterval(this.scanTimer);
      }
    }
  },
  mounted() {
    this.getAppId();
    if (this.$route.query.dt) {
      this.title = this.$route.query.dt;
      sessionStorage.setItem("dt", this.$route.query.dt);
    } else {
      if (sessionStorage.getItem("dt")) {
        this.title = sessionStorage.getItem("dt");
      }
    }
    if (this.method === 0) {
      this.getCode();
    }
    if (this.$route.query.bak) {
      sessionStorage.setItem("backImg", this.$route.query.bak);
      this.backImg =
        "https://ossimg.shangbanzugroup.com/gjy/logo/" +
        decodeURIComponent(this.$route.query.bak);
    } else {
      if (sessionStorage.getItem("backImg")) {
        this.backImg =
          "https://ossimg.shangbanzugroup.com/gjy/logo/" +
          decodeURIComponent(sessionStorage.getItem("backImg"));
      }
    }
  },
  methods: {
    getCode() {
      this.$reqGet("api/store/login/qrcode").then(res => {
        this.codeUrl = res.data.data.url;
        this.checkLogin(res.data.data.code);
      });
    },
    checkLogin(code) {
      let loadingInstance = Loading.service({
        fullscreen: false,
        background: "rgba(0,0,0,0)"
      });

      this.scanTimer = setInterval(() => {
        this.$reqGet("api/store/login/query/" + code).then(res => {
          setTimeout(() => {
            loadingInstance.close();
          }, 0);
          if (!res.data.data.continue) {
            this.isTimeOut = true;
            clearInterval(this.scanTimer);
          }
          if (res.data.data.access_token) {
            this.afterLogin(res);
          }
        });
      }, 1000);
    },
    getYzm() {
      if (this.yzmTime !== 0) {
        return;
      }
      if (!this.username) {
        this.open("用户名不能为空");
        return;
      }
      if (!this.password) {
        this.open("密码不能为空");
        return;
      }
      this.$reqPost("api/store/send_login_check_mail", {
        email: this.username
      })
        .then(res => {
          if (res.data.success) {
            this.$message({ message: "验证码已发送", type: "success" });
            this.yzmTime = 60;
            let clock = setInterval(() => {
              if (this.yzmTime > 0) {
                this.yzmTime--;
              } else {
                clearInterval(clock);
              }
            }, 1000);
          }
        })
        .catch(() => {});
    },
    checkUsername() {
      if (!this.username) {
        return;
      }
      this.$reqPost("api/store/check_mail_status", {
        email: this.username
      }).then(res => {
        this.yzmKey = res.data.data.is_locked;
      });
    },
    forget() {
      this.$router.push({ name: "forget" });
    },
    login() {
      if (!this.username) {
        this.open("用户名不能为空");
        return;
      }
      if (!this.password) {
        this.open("密码不能为空");
        return;
      }
      let userInfo = {
        username: this.username,
        password: this.password,
        loginWay: "store"
      };
      let url = "";
      if (this.yzmKey) {
        if (!this.yzm) {
          this.open("请输入验证码");
          return;
        }
        userInfo.token = this.yzm;
        userInfo.type = "email";
        url = "api/passport/login-by-token-classic";
      }
      // eslint-disable-next-line no-undef
      const captcha1 = new TencentCaptcha(this.app_id, res => {
        /* callback */
        if (res.ret === 0) {
          this.t_data = res;
          this.passLogin(userInfo, url);
        }
      });
      captcha1.show();
    },
    passLogin(userInfo, url) {
      userInfo = {
        ...userInfo,
        is_captcha_code: 1,
        randstr: this.t_data.randstr,
        ticket: this.t_data.ticket
      };
      this.$reqPost(url ? url : "api/passport/login", userInfo)
        .then(res => {
          if (res.data.status == 200) {
            this.afterLogin(res);
          }
        })
        .catch(err => {
          if (err.response.data.status === 410) {
            this.yzmKey = true;
            return;
          }
          this.password = "";
        });
    },
    login2() {
      if (!this.user.mobile) {
        this.open("手机号不能为空");
        return;
      }
      if (!this.verifyPhone()) {
        return;
      }
      if (!this.user.sms_code) {
        this.open("验证码不能为空");
        return;
      }
      // eslint-disable-next-line no-undef
      const captcha1 = new TencentCaptcha(this.app_id, res => {
        /* callback */
        if (res.ret === 0) {
          this.t_data = res;
          let userInfo = {
            username: this.user.mobile,
            token: this.user.sms_code,
            type: "phone",
            is_captcha_code: 1,
            randstr: this.t_data.randstr,
            ticket: this.t_data.ticket
          };

          this.$reqPost(
            "api/passport/login-by-token-classic?access_token=" +
              this.user.mobile,
            userInfo
          ).then(res => {
            if (res.data.status == 200) {
              this.afterLogin(res);
            }
          });
        }
      });
      captcha1.show();
    },
    afterLogin(myData) {
      this.$util.setSessionStorage({
        Authorization:
          myData.data.data.access_token || myData.data.data.accessToken
      });
      this.$reqGet("api/usercenter/info").then(res => {
        this.$util.setSessionStorage({
          nick_name: res.data.data.username || res.data.data.phone,
          avatar: res.data.data.avatar,
          user_id: res.data.data.id
        });
        let url = this.$route.query.redirect;
        if (url && url.indexOf("productDetail") != -1) {
          this.$router.replace({ path: url });
        } else {
          this.$router.replace({ path: "/" });
        }
      });
    },
    open(mes) {
      this.$message({
        message: mes,
        type: "warning"
      });
    },
    verifyPhone() {
      //手机号正则表达式
      var phoneReg = /^[1][0-9]{10}$/;
      if (!phoneReg.test(this.user.mobile)) {
        this.open("手机号格式不正确");
        return false;
      }
      return true;
    },
    getVerify() {
      if (!this.user.mobile) {
        this.open("手机号不能为空");
        return;
      }
      if (!this.verifyPhone()) {
        return;
      }

      // eslint-disable-next-line no-undef
      const captcha1 = new TencentCaptcha(this.app_id, res => {
        /* callback */
        if (res.ret === 0) {
          this.t_data = res;
          this.$reqPost(
            "api/store/verify_code?access_token=" + this.user.mobile,
            {
              mobile: this.user.mobile,
              is_captcha_code: 1,
              randstr: this.t_data.randstr,
              ticket: this.t_data.ticket
            }
          ).then(res => {
            if (res.data.success) {
              this.$message({
                message: "验证码发送成功",
                type: "success"
              });
              this.canSend = false;
              this.content = this.totalTime + "s后获取"; //这里解决60秒不见了的问题
              let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + "s后获取";
                if (this.totalTime < 0) {
                  //当倒计时小于0时清除定时器
                  window.clearInterval(clock);
                  this.content = "获取验证码";
                  this.totalTime = 60;
                  this.canSend = true;
                }
              }, 1000);
            }
          });
        }
      });
      captcha1.show();
    },
    getAppId() {
      this.$reqGet("api/g/v1/tencent/captcha-config").then(res => {
        if (res.data.success) {
          this.app_id = res.data.data.captcha_appid;
        }
      });
    }
  },
  destroyed() {
    clearInterval(this.scanTimer);
  }
};
</script>

<style lang="less" scoped>
.page-login {
  position: relative;
  margin-bottom: 20px;
}
.page-login .account_zhezhao_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.page-login .login-wrap {
  height: 600px;
}
.page-login .login-wrap .login-inner {
  position: relative;
  height: 100%;
}
.page-login .login-wrap .login-inner .login-form {
  // top: 80px;
  float: right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  width: 350px;
  // height: 450px;
  padding: 20px 20px;
  background: rgba(233, 233, 242, 1);
  border-radius: 4px;
  box-sizing: border-box;
}
.page-login .login-wrap .login-inner .login-form .user_register {
  position: absolute;
  top: 22px;
  right: 45px;
}
.page-login .login-wrap .login-inner .login-form .user_register a {
  font-size: 14px;
  color: #999;
  text-align: right;
}
.page-login .login-wrap .login-inner .login-form .login-box .mt {
  display: inline-block;
  height: 27px;
}
.page-login .login-wrap .login-inner .login-form .login-box .mt h1 {
  position: relative;
  height: 27px;
  line-height: 27px;
  top: -12px;
  float: left;
  color: #333;
  font-size: 18px;
  font: 18px "microsoft yahei", "\5b8b\4f53";
  display: block;
}

.page-login .login-wrap .login-inner .login-form .login-box .mc {
  display: block;
}
.page-login .login-wrap .login-inner .login-form .login-box .mc .form {
  display: block;
  padding: 10px 1px;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form {
  display: block;
  margin-top: 0em;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main {
  display: block;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .form-group {
  position: relative;
  margin-bottom: 28px;
  overflow: hidden;
  margin-top: 20px;
  display: flex;
  img {
    position: absolute;
    top: 12px;
    left: 18px;
    width: 20px;
    // height: 20px;
  }
  .yzm {
    width: 150px;
    height: 30px;
    border-radius: 21px;
    background: #ff4400;
    line-height: 30px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.forget {
  cursor: pointer;
}

.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .form-group
  .rest-input {
  width: 85%;
  height: 40px;
  top: 1px;
  border: none;
  border-bottom: 1px solid #dfdfdf;
  background: none;
  font-size: 15px;
  color: #252525;
  -webkit-appearance: none;
  border-radius: 3px;
  padding-left: 48px;
  outline: 0;
}

.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .form-group
  .login_get_sms {
  width: 100px;
  height: 34px;
  line-height: 34px;
  border: none;
  background-color: #ff4400;
  color: #fff;
  font-size: 13px;
  text-align: center;
  border-radius: 16px;
  position: absolute;
  top: 3px;
  right: 3px;
  outline: 0;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .form-group
  .login_get_sms:hover {
  cursor: pointer;
}

.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap {
  display: block;
  font-size: 16px;
  color: #999999;
  margin-top: 15px;
  text-align: center;
  padding: 10px 40px;
  line-height: 32px;
  img {
    width: 45px;
  }
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap
  .forget-password {
  padding-top: 10px;
  float: left;
  font-size: 14px;
  cursor: pointer;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap
  .login_accont_info {
  padding-top: 10px;
  float: right;
  font-size: 14px;
  cursor: pointer;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .btn-wrap
  .login-btn {
  text-align: center;
  cursor: pointer;
  border: 0;
  background: #ff4400;
  color: #fff;
  font-size: 18px;
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  height: 42px;
  border-radius: 21px;
  outline: 0;
}
.page-login .login-wrap .login-banner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.page-login .login-wrap .login-banner .banner {
  margin: 0 auto;
}
.page-login .login-wrap .login-banner .banner .banner-bg {
  position: relative;
  z-index: 3;
  height: 600px;
}
.code-wrap {
  position: relative;
  text-align: center;
  .code {
    margin-top: 10px;
    width: 150px;
    height: 150px;
  }
  .refresh-wrap {
    position: absolute;
    top: 10px;
    left: 80px;
    width: 150px;
    height: 150px;
    background-color: rgba(0, 1, 1, 0.6);
    color: #eee;
    cursor: pointer;
    i {
      font-size: 24px;
      color: #fff;
      margin-top: 40px;
    }
  }
}

.saoma {
  margin-top: 15px;
  line-height: 22px;
  color: #999;
  .el-col:first-child {
    text-align: right;
    padding-right: 10px;
    img {
      width: 30px;
      height: 30px;
      margin-top: 6px;
    }
  }

  .orange {
    color: #fc5e26;
  }
}
.rest-f-tail {
  padding: 40px;
  background-color: #fff;
  text-align: center;
  a,
  span {
    color: #494949;
    min-width: 100px;
    border-right: 1px solid #ddd;
    line-height: 26px;
  }
  .rest-f-legal-link {
    span:last-child {
      border: none;
    }
  }
  a:last-child {
    border: none;
  }
  a:hover {
    color: #55c3fd;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/login.vue